import React, { useEffect, useState } from "react";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { popupOpenClose } from "../../../action/action";
import { CMSPath } from "../../../config/constant";
import { scrollToTop } from "../../../JS/scrollToTop";



const SpaBooking3d = (props) => {

    const { t } = props;
    // const [details, setDetails] = useState({
    //     "email": "",
    //     "mobileNumber": "",
    //     "guestNotes": ""
    // })

    const handleBack = () => {
        props.goBack();
    }

    const handleNext = () => {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (!(props.isAnyPrevReservForAnyLocation || props.updateReservationDetails)) {

            if (props.additionalDetails.mobileNumber == "") {
                props.popupOpenClose(true, t('spaBooking.enter_mobileNumber'))
                return;
            }

            if (props.additionalDetails.email == "") {
                props.popupOpenClose(true, t('spaBooking.enter_email'))
                return;
            }

            if (!emailRegex.test(props.additionalDetails.email)) {
                props.popupOpenClose(true, "Please enter a valid email");
                return;
            }
        }

        console.log('customerdetail', props.additionalDetails)
        // props.setAdditionalDetails(props.additionalDetails)
        props.handleNextToSummaryPage()
    }

    useEffect(() => {
        scrollToTop();
    }, [])

    return (
        <>
            <section class="widgets spa-listing spa-details">

                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl &&
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{t('spaBooking.heading3d')}</div>
                    {/* <div>{t(`resReservationV2.heading2a`)}</div> */}
                </div>

                <div class="widgets">
                    <div class="row margin-bottom-2">
                        <div class="row">
                            <div class="col">

                                <div class="detail-body stay-body">
                                    <form>

                                        {!(props.isAnyPrevReservForAnyLocation || props.updateReservationDetails)
                                            &&
                                            <div class="form-row">
                                                <p class="heading">{t('spaBooking.phone_number')} <span style={{ color: "red" }}>*</span></p>
                                                <input type="tel" value={props.additionalDetails.mobileNumber} onChange={(e) => props.setAdditionalDetails({ ...props.additionalDetails, mobileNumber: e.target.value })} placeholder={t('spaBooking.mobileNumber_placeholder')} />
                                            </div>}



                                        {!(props.isAnyPrevReservForAnyLocation || props.updateReservationDetails)
                                            &&
                                            <div class="form-row">
                                                <p class="heading">{t('spaBooking.email')} <span style={{ color: "red" }}>*</span></p>
                                                <input type="text" value={props.additionalDetails.email} onChange={(e) => props.setAdditionalDetails({ ...props.additionalDetails, email: e.target.value })} placeholder={t('spaBooking.email_placeholder')} />
                                            </div>}

                                        <div class="form-row">
                                            <p class="heading">{t('spaBooking.guestNotes')}</p>
                                            <textarea rows="5" value={props.additionalDetails.guestNotes} onChange={(e) => props.setAdditionalDetails({ ...props.additionalDetails, guestNotes: e.target.value })} placeholder={t('spaBooking.guestNotes_placeholder')}></textarea>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-controls">
                                <button onClick={handleNext}>{t('spaBooking.continue')}</button>
                                <button onClick={handleBack}>{t('spaBooking.back')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        serverTimeDate: state.store.home.serverTimeDate.date,
        menuColor: state.store.home.MenuColor,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        gmtOffset: state.store.home.serverTimeDate.gmtOffset,
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM
    }
}

export default connect(mapStateToProps, { popupOpenClose })(withTranslation('translations')(SpaBooking3d));